import { Stack, Typography } from "@mui/material"
import { ChartsTooltipContainer, useItemTooltip } from "@mui/x-charts"
import CircleIcon from "@mui/icons-material/Circle"
import ChartTooltipCard from "widgets/plots/mui/ChartTooltipCard"

const MuiPieTooltip = () => {
  const item = useItemTooltip()

  return (
    <ChartsTooltipContainer trigger="item">
      {item && (
        <ChartTooltipCard>
          <Stack direction="row" gap={1} alignItems="center" width={"100%"}>
            <CircleIcon sx={{ fontSize: 8, color: item.color }} />
            <Stack
              direction="row"
              justifyContent={"space-between"}
              width={"100%"}
              gap={2}
            >
              <Typography>{item.label}</Typography>
              <Typography>{item.formattedValue}</Typography>
            </Stack>
          </Stack>
        </ChartTooltipCard>
      )}
    </ChartsTooltipContainer>
  )
}

export default MuiPieTooltip
